module.exports = __webpack_public_path__ + "components/flag/static/square/ye-ade1487337ca1a9bab82a55990b2b561.svg";